import microApp from "@micro-zoe/micro-app"
import * as config from "./config"
import { addSonAppsDataListener, microAppSetGlobalData, microAppForceSetGlobalData } from "@/micro/micro-app-utils"
import store from "@/store"
// 引入全局子应用通信管理处理方式
// eslint-disable-next-line no-unused-vars
import * as globals from "./global-controller-for-son-apps"
import { MICRO_APPS, sysBelongConfig } from "./config"
import axios from "axios"

const microArr = []
for (const microArrKey in config.MICRO_APPS) {
  const obj = {
    name: config.MICRO_APPS[microArrKey]["name"],
    url: microArrKey,
    prefetchDelay: 1000
  }
  // 监听子应用发来的消息
  addSonAppsDataListener(obj.name)
  if (process.env.VUE_APP_ENV === "test") {
    obj.url = config.MICRO_APPS[microArrKey]["testUrl"]
    if (process.env.VUE_APP_BASE_API === "https://gray.tfeimall.com") {
      obj.url = config.MICRO_APPS[microArrKey]["graysUrl"]
    }
  } else if (process.env.VUE_APP_ENV === "production") {
    obj.url = config.MICRO_APPS[microArrKey]["url"]
  }
  microArr.push(obj)
}
/** 预加载子应用数据 */
microApp.preFetch(() => microArr)

/** 启用 micro */
microApp.start({
  "router-mode": "native",
  "keep-alive": true, // 保活
  "disable-memory-router": true, // 全局关闭虚拟路由系统，默认值false
  lifeCycles: {
    created(e) {
      // console.log(e.detail.name + ":created")
      // 同步侧边栏状态
      microAppSetGlobalData({ type: "sidebarOpened", data: store.state.app.sidebar.opened })
    },
    beforemount(e) {
      // console.log(e.detail.name + ":beforemount")
    },
    mounted(e) {
      // 同步侧边栏状态
      microAppSetGlobalData({ type: "sidebarOpened", data: store.state.app.sidebar.opened })
    },
    unmount(e) {
      // console.log(e.detail.name + ":unmount")
    },
    error(e) {
      // console.log(e.detail.name + ":error")
    },
    afterhidden(e) {},
    beforeshow(e) {
      // 解决非当前页面关闭后，缓存问题
      const newHideCloseTags = JSON.parse(JSON.stringify(store.state.tagsView.hideCloseTags))
      for (let i = 0; i < newHideCloseTags.length; i++) {
        const newView = newHideCloseTags[i]
        if (newView.sysBelong === sysBelongConfig[e.detail.name]) {
          newHideCloseTags.splice(i, 1)
          i--
        }
      }
      // console.log("beforeshow")
      // console.log(store.state.tagsView.hideCloseTags)
      if (store.state.tagsView.hideCloseTags.length > 0) {
        microAppForceSetGlobalData({
          type: "store",
          data: { fnType: "dispatchArr", nameSpace: "tagsView/delView", fnData: store.state.tagsView.hideCloseTags }
        })
      }
      store.dispatch("tagsView/updateHideCloseTags", newHideCloseTags)
    },
    aftershow(e) {}
  }
})

// 检查版本，提示更新
window.$checkVersion = appName => {
  let versionUrl = ""
  for (const microappsKey in MICRO_APPS) {
    if (MICRO_APPS[microappsKey]["name"] === appName) {
      if (process.env.VUE_APP_ENV === "test") {
        versionUrl = MICRO_APPS[microappsKey]["testUrl"]
      } else if (process.env.VUE_APP_ENV === "production") {
        versionUrl = MICRO_APPS[microappsKey]["url"]
      }
    }
  }
  return new Promise(resolve => {
    axios
      .get(versionUrl + "/version.json?v=" + new Date().getTime(), {
        headers: { "Cache-Control": "no-cache" },
        baseURL: window.location.origin
      })
      // 请求json文件的内容, 并且禁止缓存
      .then(res => {
        const latestVersion = res.data.version
        const currentPageVersion = Number(document.querySelector(`meta[name="${appName}Version"]`).content || "")
        console.log("latestVersion")
        console.log(latestVersion)
        console.log("currentPageVersion")
        console.log(currentPageVersion)
        resolve(latestVersion === currentPageVersion)
      })
      .catch(err => {
        console.log("checkVersion err", err)
      })
  })
}
